import React from 'react';

import { Tr } from '@chakra-ui/react';

import CompositionGroupTable from './CompositionGroupTable';
import {
  formatCurrency,
  formatDecimal,
  formatDistance,
  formatQuantity,
} from './formatters';
import { StyledTd, StyledTh } from './StyledTableCell';

export type TimeOfTransportDetail = {
  auxiliaryCode: string;
  dmtKm: number;
  unitaryValue: number;
  coefficient: number;
};

export type TimeOfTransportGroupRow = {
  code: string;
  description: string;
  quantity: number;
  unit: string;
  dmt: {
    ln: TimeOfTransportDetail;
    rp: TimeOfTransportDetail;
    p: TimeOfTransportDetail;
    fe: TimeOfTransportDetail;
  };
  hourlyCost: number;
};

type TimeOfTransportGroupTableProps = {
  data: TimeOfTransportGroupRow[];
};

const TimeOfTransportGroupTable: React.FC<TimeOfTransportGroupTableProps> = ({
  data,
}) => {
  const totalFitCost = 492.36;
  const totalTransportUnitCost = 2329.9613;

  const renderDmtCell = (detail: TimeOfTransportDetail): JSX.Element => (
    <>
      <div>{detail.auxiliaryCode}</div>
      <div>{formatDistance(detail.dmtKm)} km</div>
      <div>{formatCurrency(detail.unitaryValue)}</div>
      <div>{formatDecimal(detail.coefficient * detail.unitaryValue)}</div>
    </>
  );

  return (
    <CompositionGroupTable
      headerRows={
        <>
          <Tr>
            <StyledTh colSpan={2}>F - Momento de Transporte</StyledTh>
            <StyledTh textAlign="center" width="90px">
              Quantidade
            </StyledTh>
            <StyledTh textAlign="center" width="90px">
              Unidade
            </StyledTh>
            <StyledTh colSpan={3} textAlign="center">
              DMT
            </StyledTh>
            <StyledTh textAlign="right" width="140px">
              Custo Horário
            </StyledTh>
          </Tr>
          <Tr>
            <StyledTh colSpan={2} />
            <StyledTh />
            <StyledTh />
            <StyledTh textAlign="center">LN</StyledTh>
            <StyledTh textAlign="center">RP</StyledTh>
            <StyledTh textAlign="center">P</StyledTh>
            <StyledTh />
          </Tr>
        </>
      }
      bodyRows={
        <>
          {data.map((item) => (
            <Tr key={item.code}>
              <StyledTd width="1%" minWidth="50px" whiteSpace="nowrap">
                {item.code}
              </StyledTd>
              <StyledTd
                minWidth="220px"
                whiteSpace="normal"
                overflowWrap="break-word"
                wordBreak="break-word"
              >
                {item.description}
              </StyledTd>
              <StyledTd textAlign="center">
                {formatQuantity(item.quantity)}
              </StyledTd>
              <StyledTd textAlign="center">{item.unit}</StyledTd>
              <StyledTd textAlign="right">
                {renderDmtCell(item.dmt.ln)}
              </StyledTd>
              <StyledTd textAlign="right">
                {renderDmtCell(item.dmt.rp)}
              </StyledTd>
              <StyledTd textAlign="right">{renderDmtCell(item.dmt.p)}</StyledTd>
              <StyledTd textAlign="right">
                {formatCurrency(item.hourlyCost)}
              </StyledTd>
            </Tr>
          ))}

          <Tr>
            <StyledTd colSpan={7} textAlign="right" fontWeight="600">
              Custo do FIT
            </StyledTd>
            <StyledTd textAlign="right" fontWeight="600">
              {formatCurrency(totalFitCost)}
            </StyledTd>
          </Tr>
          <Tr>
            <StyledTd colSpan={7} textAlign="right" fontWeight="600">
              Custo unitário total de transporte
            </StyledTd>
            <StyledTd textAlign="right" fontWeight="600">
              {formatCurrency(totalTransportUnitCost)}
            </StyledTd>
          </Tr>
        </>
      }
    />
  );
};

export default TimeOfTransportGroupTable;
